<template>
  <div
    :class="{open:open}"
    class="main-menu">
    <div class="icons-container">
      <div class="icons-wrapper">
        <router-link
          v-for="item in menuItems"
          v-if="validateProfile(item)"
          :class="{active : defaultActive === item.route}"
          :to="{name:item.route}"
          :key="item.route"
          :title="item.label">
          <i :class="item.icon"/>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppMenu',
  props: {
    open: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    menuItems () {
      return [
        {
          icon: 'icon-home',
          label: 'Dashboard',
          route: 'dashboard',
          permission: ['superadmin', 'territorial_agco', 'gerente_dealer', 'gerente_branch', 'vendedor_dealer']
        },
        {
          icon: 'icon-users',
          label: 'Clientes',
          route: 'customers',
          permission: ['superadmin', 'gerente_branch', 'vendedor_dealer', 'gerente_dealer']
        },
        {
          icon: 'icon-check-square',
          label: 'Tareas',
          route: 'tasks',
          permission: ['superadmin', 'gerente_branch', 'vendedor_dealer']
        },
        {
          icon: 'icon-mail',
          label: 'Campañas',
          route: 'campaigns-list-recent',
          permission: ['gerente_branch', 'vendedor_dealer']
        },
        {
          icon: 'icon-mail',
          label: 'Campañas',
          route: 'campaigns-list-approve',
          permission: ['superadmin']
        },
        {
          icon: 'icon-mail',
          label: 'Campañas',
          route: 'campaigns-pre-approve',
          permission: ['gerente_dealer']
        },
        {
          icon: 'icon-distribuidor',
          label: this.profile.role === 'superadmin' || this.profile.role === 'territorial_agco' ? 'Objetivos distribuidores' : 'Objetivos',
          route: 'goals',
          permission: ['superadmin', 'territorial_agco', 'gerente_dealer', 'gerente_branch', 'vendedor_dealer']
        },
        {
          icon: 'icon-sucursal',
          label: 'Objetivos sucursal',
          route: 'admin-goals-branch',
          permission: ['superadmin', 'territorial_agco']
        },
        {
          icon: 'icon-territorial',
          label: 'Objetivos territorial',
          route: 'goals-target',
          permission: ['superadmin']
        },
        {
          icon: 'icon-book-open',
          label: 'Reportes',
          route: 'report-list',
          permission: ['superadmin', 'territorial_agco', 'gerente_dealer', 'gerente_branch']
        },
        {
          icon: 'icon-briefcase',
          label: 'Vendedores',
          route: 'dealer',
          permission: ['superadmin', 'gerente_dealer']
        },
        {
          icon: 'icon-user-change',
          label: 'Reasignar',
          route: 'reassignment',
          permission: ['gerente_branch']
        }
      ]
    },
    profile () {
      return this.$store.getters['profile/me']
    },
    defaultActive () {
      let route = ''
      switch (this.$route.name) {
        case 'dashboard':
          route = 'dashboard'
          break
        case 'customers-info':
          route = 'customers'
          break
        case 'tasks':
          route = 'tasks'
          break
        case 'campaigns-list-recent':
          route = 'campaigns-list-recent'
          break
        case 'campaigns-list-approve':
          route = 'campaigns-list-approve'
          break
        case 'seller-my-goals':
        case 'goals-dealer':
        case 'goals-seller':
        case 'goals-branch':
          route = 'goals'
          break
        case 'admin-goals-branch':
          route = 'admin-goals-branch'
          break
        case 'goals-target-branch':
          route = 'goals-target'
          break
        case 'report-list':
          route = 'report-list'
          break
        case 'dealer':
          route = 'dealer'
          break
      }
      return route
    }
  },
  methods: {
    validateProfile (profile) {
      let hasPermission = []
      for (let permission of profile.permission) {
        if (permission === this.profile.role) {
          hasPermission.push(permission)
        }
      }
      if (hasPermission.length > 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .main-menu {
    background-color: $primary;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    .icons-container {
      position: relative;
      height: 100%;
      width: 100%;
      background-color: #DC281E;
      display: flex;
      align-items: flex-start;
      z-index: 10;
      .icons-wrapper {
        margin: 20px auto;
        width: 60px;
        a {
          color: #fff;
          font-size: 22px;
          height: 60px;
          text-decoration: none;
          display: flex;
          justify-content: center;
          align-items: center;
          i{
            color: #fff;
            font-size: 16px;
          }
        }
        .active {
          background-color: rgba(0, 0, 0, 0.15);
        }
        i.icon-distribuidor {
          background-image: url('~@/assets/objetivos/distribuidor.svg');
          width: 18px;
          height: 18px;
          background-repeat: no-repeat;
          background-size: cover;
        }
        i.icon-sucursal {
          background-image: url('~@/assets/objetivos/sucursal.svg');
          width: 18px;
          height: 18px;
          background-repeat: no-repeat;
          background-size: cover;
        }
        i.icon-territorial {
          background-image: url('~@/assets/objetivos/territorial.svg');
          width: 18px;
          height: 18px;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/app-menu.vue